'use client'

import { LayoutBreadcrumbsOverride } from '@/app/layout/MainSiteLayout/LayoutBreadcrumbsOverride'

import { CatalogBrands } from '@/screens/catalog-brands'

import { CatalogBrandsInitialDataProvider } from '@/features/catalog-brands/initial-data'

import { CatalogBrandsProductsData, FilterData } from '@/entities/catalog-brands'
import { SeoResponse } from '@/entities/catalog-brands/types/type'

import { TPage } from '@/shared/types/deprecated-types'

type Props = {
	seoData: SeoResponse
	breadcrumbs: TPage[]
	initialFilterData: FilterData | null
	initialProductsData: CatalogBrandsProductsData | null
	initialResolvedUrl: string
}

const BrandDetailPageContent = ({ seoData }: { seoData: SeoResponse }) => {
	return <CatalogBrands title={seoData.SECTION_PAGE_TITLE} />
}

export function BrandDetailClient({
	seoData,
	breadcrumbs,
	initialFilterData,
	initialProductsData,
	initialResolvedUrl
}: Props) {
	return (
		<>
			<LayoutBreadcrumbsOverride pages={breadcrumbs} />
			<CatalogBrandsInitialDataProvider
				value={{
					initialFilterData,
					initialDetailedSectionData: null,
					initialProductsData,
					initialResolvedUrl
				}}>
				<BrandDetailPageContent seoData={seoData} />
			</CatalogBrandsInitialDataProvider>
		</>
	)
}
